import { render } from "./Delete.vue?vue&type=template&id=30a8b8b8&scoped=true"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-30a8b8b8"

export default script